const hideHeaderSection = (counts = {}) => {
  const resultsContainer = document.querySelector('[data-search-results-content]');
  const hasAnyTabResults = counts?.hasAnyResultTypeTabResults ??
    ((counts?.listingCount ?? 0) > 0 || (counts?.homesCount ?? 0) > 0);
  const isNoResults = (counts?.listingCount ?? 0) === 0;
  const hiddenSections = document.querySelectorAll('[data-hidden-section]');
  const tabSections = Array.from(hiddenSections).filter((element) =>
    element.querySelector('[data-result-type-bar]'));

  if (!isNoResults) {
    hiddenSections.forEach(element => element.removeAttribute('hidden'));
    resultsContainer.classList.remove('nhs-c-wrapper--no-results', 'nhs-mq-wrapper--no-results-medium');
    return;
  }

  hiddenSections.forEach((element) => {
    if (tabSections.includes(element)) {
      if (hasAnyTabResults) {
        element.removeAttribute('hidden');
        return;
      }

      element.setAttribute('hidden', '');
      return;
    }

    element.setAttribute('hidden', '');
  });
  resultsContainer.classList.add('nhs-c-wrapper--no-results', 'nhs-mq-wrapper--no-results-medium');
};

export default hideHeaderSection;